export class D365Service {
  constructor(API, Auth, ItCache) {
    'ngInject';

    this.Auth = Auth;
    this.API = API;
    this.ItCache = ItCache;
  }

  getClientMappers() {
    return this.Auth.httpWithAuthToken({
      url: `${this.API.root}/d365/client-mappers`
    });
  }

  saveClientClientMapper(clientId, d365ClientId, d365ClientName, d365ClientTaxId) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: `${this.API.root}/d365/client-mappers`,
      data: {clientId, d365ClientId, d365ClientName, d365ClientTaxId}
    });
  }

  deleteClientClientMapper(clientId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: `${this.API.root}/d365/client-mappers/${clientId}`
    });
  }

  getPGMappers() {
    return this.Auth.httpWithAuthToken({
      url: `${this.API.root}/d365/process-group-mappers`
    });
  }

  savePGPGMapper(processGroupId, d365ProcessGroupName, d365HierarchyId, d365ProcessGroupDescription) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: `${this.API.root}/d365/process-group-mappers`,
      data: {processGroupId, d365ProcessGroupName, d365HierarchyId, d365ProcessGroupDescription}
    });
  }

  deletePGPGMapper(processGroupCountryConfigurationId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: `${this.API.root}/d365/process-group-mappers/${processGroupCountryConfigurationId}`
    });
  }

  getProcessesMappers(processGroupCountryConfigurationId) {
    return this.Auth.httpWithAuthToken({
      url: `${this.API.root}/d365/${processGroupCountryConfigurationId}/process-mappers`
    });
  }

  saveProcessMapper(processId, d365ProcessId, d365HierarchyId, d365ProcessName) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: `${this.API.root}/d365/process-mappers`,
      data: {processId, d365ProcessId, d365HierarchyId, d365ProcessName}
    });
  }

  deleteProcessMapper(processId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: `${this.API.root}/d365/process-mappers/${processId}`
    });
  }

  getClientsD365(name) {
    return this.ItCache.get(
      `d365-clients-${name.toLowerCase()}`,
      () => {
        return this.Auth.httpWithAuthToken({
          method: 'POST',
          url: `${this.API.root}/d365/clients`,
          data: {name}
        });
      },
      60 * 60 * 1_000,
      true
    );
  }

  getInterrupts() {
    return this.Auth.httpWithAuthToken({
      url: `${this.API.root}/d365/interrupt-mappers`
    });
  }

  getInterruptsD365(name) {
    return this.ItCache.get(
      `d365-interrupts-${name.toLowerCase()}`,
      () => {
        return this.Auth.httpWithAuthToken({
          method: 'POST',
          url: `${this.API.root}/d365/interrupts`,
          data: {name}
        });
      },
      60 * 60 * 1_000,
      true
    );
  }

  saveInterrupttMapper(interruptCountryConfigurationId, d365InterruptId, d365InterruptName, d365HierarchyId, appliesToClient) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: `${this.API.root}/d365/interrupt-mappers`,
      data: {interruptCountryConfigurationId, d365InterruptId, d365InterruptName, d365HierarchyId, appliesToClient}
    });
  }

  deleteInterruptMapper(interruptId, appliesToClient) {
    var params = {
      appliesToClient: appliesToClient
    };
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: `${this.API.root}/d365/interrupt-mappers/${interruptId}`,
      params: params
    });
  }
}
